import {deepClone} from '@/util/util'
import {getStore} from '@/util/store'
import {isGuoShouCai, isPingAnQingDao, isQianHai, isSanXingTuanYi} from 'meibao-insure/src/util/productUtil'
import {SettleType} from '@/const/enum'
//处理档次用的数据
export const feeRateDangCiDic = {
	8: [
		{
			label: '全部',
			value: 0,
		},
		{
			label: '国寿财团意1档',
			value: 100,
		},
		{
			label: '国寿财团意2挡',
			value: 110,
		},
		{
			label: '国寿财团意3挡',
			value: 115,
		},
	],
	15: [
		{
			label: '全部',
			value: 0,
		},
		{
			label: '前海财险1档',
			value: 100,
		},
		{
			label: '前海财险2挡',
			value: 200,
		},
	],
	34: [
		{
			label: '全部',
			value: 0,
		},
		{
			label: '三星1-6类团意险(1档)',
			value: 100,
		},
		{
			label: '三星1-6类团意险(2档)',
			value: 200,
		},
		{
			label: '三星1-6类团意险(3档)',
			value: 300,
		},
	],
	41: [
		{
			label: '全部',
			value: 0,
		},
		{
			label: '平安1-5类团意险(1档)',
			value: 100,
		},
		{
			label: '平安1-5类团意险(2档)',
			value: 200,
		},
	],
}

//获取结算费率
export function getSettleProductData() {
	let rateItemData = {
		insureName: '',
		insureType: 0,
		feeRatePercent: null,
		basicFeeRate: '',
		additionalFeeRate: '',
	}

	//处理特殊情况！！ 国寿财 有1 2 3档次 ，前海 有100  200
	let tempInsureTypes = getStore({name: 'insureTypes'})

	let tempRateData = tempInsureTypes.map(({abbreviation, type}) => {
		return Object.assign(deepClone(rateItemData), {insureName: abbreviation, insureType: type})
	})
	//国寿财
	let tempGscIndex = tempRateData.findIndex(({insureType}) => isGuoShouCai(insureType))
	if (tempGscIndex !== -1) {
		tempRateData.splice(
			tempGscIndex,
			1,
			Object.assign(deepClone(rateItemData), {insureName: '国寿财(1档)', insureType: 8, feeRatePercent: 100}),
			Object.assign(deepClone(rateItemData), {insureName: '国寿财(2档)', insureType: 8, feeRatePercent: 110}),
			Object.assign(deepClone(rateItemData), {insureName: '国寿财(3档)', insureType: 8, feeRatePercent: 115}),
		)
	}
	//前海
	let tempQhIndex = tempRateData.findIndex(({insureType}) => isQianHai(insureType))
	if (tempQhIndex !== -1) {
		tempRateData.splice(
			tempQhIndex,
			1,
			Object.assign(deepClone(rateItemData), {insureName: '前海雇主险 (1档)', insureType: 15, feeRatePercent: 100}),
			Object.assign(deepClone(rateItemData), {insureName: '前海雇主险 (2档)', insureType: 15, feeRatePercent: 200}),
		)
	}
	//前海
	let tempSxIndex = tempRateData.findIndex(({insureType}) => isSanXingTuanYi(insureType))
	if (tempSxIndex !== -1) {
		tempRateData.splice(
			tempSxIndex,
			1,
			Object.assign(deepClone(rateItemData), {insureName: '三星1-6类团意险(1档)', insureType: 34, feeRatePercent: 100}),
			Object.assign(deepClone(rateItemData), {insureName: '三星1-6类团意险(2档)', insureType: 34, feeRatePercent: 200}),
			Object.assign(deepClone(rateItemData), {insureName: '三星1-6类团意险(3档)', insureType: 34, feeRatePercent: 300}),
		)
	}

	//青岛平安
	let tempPAIndex = tempRateData.findIndex(({insureType}) => isPingAnQingDao(insureType))
	if (tempPAIndex !== -1) {
		tempRateData.splice(
			tempPAIndex,
			1,
			Object.assign(deepClone(rateItemData), {insureName: '平安1-5类团意险(1档)', insureType: 41, feeRatePercent: 100}),
			Object.assign(deepClone(rateItemData), {insureName: '平安1-5类团意险(2档)', insureType: 41, feeRatePercent: 200}),
		)
	}
	return tempRateData
}

//获取结算中有档次的产品
export function getHasFeeRateBySettle(insureType) {
	let tempInsureTypes = getStore({name: 'insureTypes'}) || []
	return tempInsureTypes.findIndex(({hasFeeRate = 0, type}) => hasFeeRate === 1 && type == insureType) === -1
}

export function getHasFeeRateBySettleByRate(feeRatePercent, insureType) {
	if (getHasFeeRateBySettle(insureType)) {
		return '--'
	}
	switch (feeRatePercent) {
		case 100:
			return '一档'
		case 110:
			return '二档'
		case 200:
			return '二档'
		case 115:
			return '三档'
		case 300:
			return '三档'
		default:
			return '全部'
	}
}

/**
 *
 * @param {*} settleType 结算类型
 * @returns
 */
export function isSettlePrivate(settleType = '') {
	return !settleType || settleType === SettleType.PRIVATE || settleType === SettleType.AGENT
}

/**
 * 处理结算类型
 * @param {*} settleType 结算类型
 * @returns
 */
export function onGetSettleType(settleType = '') {
	return isSettlePrivate(settleType) ? SettleType.PRIVATE : SettleType.PUBLIC
}

/**
 * 判断两个settleType是否相同
 * @param {*} settleType 结算类型
 * @param {*} compareSettleType 比较的结算类型
 * @returns
 */
export function isSettleTypeSame(settleType = '', compareSettleType = '') {
	return onGetSettleType(settleType) === onGetSettleType(compareSettleType)
}
